import { apibase, apikey, resultCount } from './config.js';
import { errorMessage } from './stores.js';

class PXL {
  detect(url) {
    return this.request(`/detect?url=${encodeURIComponent(url)}`, json => json.list || json);
  }

  detect_by_file(element) {
    const formData = new FormData();
    formData.append('file', element.files[0]);
    return this.request(`/detect`, json => json.list || json, {
      method: 'POST',
      body: formData,
    }, true);
  }

  analyze(url) {
    return this.request(`/analyze?url=${encodeURIComponent(url)}&lang=en`, json => json.list || json);
  }

  analyze_by_file(element) {
    const formData = new FormData();
    formData.append('file', element.files[0]);
    return this.request(`/analyze?lang=en`, json => json.list || json, {
      method: 'POST',
      body: formData,
    }, true);
  }

  search(regionId, gender, c2, c3, c4, attrs, flex_mode, filter_by_hash) {
    let url = `/search/${regionId}`;
    if (apibase.indexOf('/v1') > -1) {
      let searchCategory = gender | c2;
      const flex_query = {};
      if (c3 !== undefined) {
        flex_query["sub_category"] = c3;
      }
      // FIXME: Support attribute search
      if (attrs && attrs.length > 0) {
        flex_query["attributes"] = attrs;
      }
      if (typeof regionId === 'string' && regionId.indexOf('_') < 0 && regionId.indexOf(',') < 0) {  // tonic
        return this.request(`${url}?count=${resultCount}`, json => json.list[parseInt(Object.keys(json.list)[0])]);
      }
      // mode parameter is deprecated from v1 api. use default value only.
      return this.request(`${url}?gender=${gender}&category=${searchCategory}&count=${resultCount}`,
        json => json.list[parseInt(Object.keys(json.list)[0])],
        {
          method: 'POST',
          body: JSON.stringify(flex_query),
        }
      );
    }
    // v2 & v3
    else {
      let query = `${url}?genders=${gender}&count=${resultCount}`
      if (filter_by_hash !== undefined) query = `${query}&filter_by_hash=${filter_by_hash}`
      if (flex_mode !== 0) query = `${query}&mode=${flex_mode}`

      if (flex_mode !== 0 && c3) {
        return this.request(`${query}&category=${c2}`,
          undefined,
          {
            method: 'POST',
            body: `c3 = "${c3}"`,
          },
          false,
          'text/plain'
        );
      }
      else {
        return this.request(`${query}&category=${c4 ? c4 : c3 ? c3 : c2}`);
      }
    }
  }

  tonic(url) {
    return this.request(`/search?url=${encodeURIComponent(url)}&count=${resultCount}`);
  }

  recommend(regionId, mode, gender, category) {
    let path = `/stylist/${regionId}`;
    let query = `genders=${gender}&category=${category}`;
    if (apibase.indexOf('/v1') > -1) {
      path = `/recommend/stylist/${regionId}`;
      query = `category=${gender | category}`;
    }
    return this.request(`${path}?${query}&count=${resultCount}&mode=${mode}`, json => json.list || json);
  }

  request(query, parse, options, isFile, content_type='application/json') {
    const is_apikey = apikey.length > 56;
    const headers = {
      [is_apikey ? "ApiKey" : "bucketname"]: apikey,
    };
    if (isFile !== true) {
      headers["Content-Type"] = content_type;
    }
    if (parse === undefined) {
      parse = json => json;
    }
    return fetch(`${apibase}${query}`, {
      ...options,
      headers,
    }).then(async res => {
      if (!res.ok) {
        throw await res.json();
      }
      return res.json();
    }).then(json => {
      if (json.status === false) {
        throw json.message || 'API status is false.';
      }
      return parse(json);
    }).catch(err => {
      if (query.indexOf('/analyze') === 0) {
        console.log('Analyze API failed.');
        return;
      } else if (query.indexOf('/stylist') === 0 && query.indexOf('mode=0') > -1) {
        console.log('Stylist API failed.');
        return [];
      }
      errorMessage.set(err);
    });
  }
}

export default PXL;
